<template>
  <div class="container">
    <my-nav-ui :idx="1"></my-nav-ui>
    <div class="bottom">
      <div class="left">
        <div
          class="content row1"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        >
          <label>全年年检维保异常状态统计</label>
          <div id="charts1" style="height: calc(50% - 15px); width: 100%"></div>
          <div id="charts2" style="height: calc(50% - 15px); width: 100%"></div>
        </div>
        <div
          class="content row2"
          id="charts3"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        ></div>
      </div>
      <div class="center">
        <div
          class="content row1"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        >
          <label>全年处理情况统计</label>
          <div class="num">
            <div>
              <span>处理总数</span>
              <span class="color1">{{
                totalAlarmCount + totalFaultCount + complaintTotalCount
              }}</span>
            </div>
            <div>
              <span>累计人工报警</span>
              <span class="color2">{{ totalAlarmCount }}</span>
            </div>
            <div>
              <span>累计异常</span>
              <span class="color3">{{ totalFaultCount }}</span>
            </div>
            <div>
              <span>累计投诉</span>
              <span class="color4">{{ complaintTotalCount }}</span>
            </div>
          </div>
        </div>
        <div class="row2">
          <div
            class="content row2l1"
            id="charts4"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="#121D49"
          ></div>
          <div
            class="content row2l2"
            id="charts5"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="#121D49"
          ></div>
        </div>
        <div
          class="content row3"
          id="charts6"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        ></div>
      </div>
      <div class="right">
        <div
          class="content row1"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        >
          <label v-if="cityName=='全国'">全国各区县电梯分布情况统计</label>
          <label v-if="cityName!=='全国'">全市各区县电梯分布情况统计</label>
          <div
            id="charts7"
            style="height: calc(100% - 30px); width: 100%"
          ></div>
        </div>
        <div
          class="content row2"
          id="charts8"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from '@/api/global_variable'
import chartsView1 from '@/api/charts_view1'
export default {
  name: 'EchartsView1',
  data() {
    return {
      loading: true,
      ViewData: null,
      requestNum: 1,
      TimerFlag: true,
      CurCity: null,
      Timer: null,
      perMonthList: [],
      maintainBymonthList: [],
      annualBymonthList: [],
      totalAlarmCount: 0,
      totalFaultCount: 0,
      complaintTotalCount: 0,
      fixingByareaList: [],
      faultTotalAlarmCount: [],
      faultTotalFaultCount: [],
      complaintYearTotalCount: [],
      cityName: ''
    }
  },
  beforeDestroy() {
    clearInterval(this.Timer)
    this.Timer = null
  },
  mounted() {
    if (!GLOBAL.isLogin()) {
      this.$router.push({ path: '/login' })
    } else {
      GLOBAL.curPage = 1
      this.loading = false
      chartsView1.setEcharts(this.$echarts)
      this.drawCharts()
      if (this.Timer === null) {
        var that = this
        this.Timer = setInterval(function () {
          that.drawCharts()
        }, 30000)
      }
    }
  },
  created() {
    this.drawCharts()
    this.cityName = sessionStorage.getItem('cityName')
  },
  methods: {
    drawCharts: function () {
      this.orgId = this.$route.params.orgId
      if (GLOBAL.curPage === 1) {
        this.drawView1Charts1()
        this.drawView1Charts2()
        this.drawView1Charts3()
        this.drawView1Charts4()
        this.drawView1Charts5()
        this.drawView1Charts6()
        this.drawView1Charts7()
        this.drawView1Charts8()
        this.drawView1Charts9()
      }
    },
    rondamColor: function () {
      var r = Math.ceil(Math.random() * 3)
      return 'color' + r
    },
    // 未按期维保
    drawView1Charts1: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/maintain/delay/byarea',
      }).then((res) => {
        var v = []
        for (var i = 0; i < res.data.result.length; i++) {
          v.push({
            name: res.data.result[i].groupName,
            value: res.data.result[i].totalCount,
          })
        }
        var option = chartsView1.getOption1(v)
        var div_ = document.getElementById('charts1')
        div_.removeAttribute('_echarts_instance_')
        var chart1 = this.$echarts.init(div_)
        chart1.setOption(option, true)
      })
    },
    // 未按期年检
    drawView1Charts2: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/annual/delay/byarea',
      }).then((res) => {
        var v = []
        for (var i = 0; i < res.data.result.length; i++) {
          v.push({
            name: res.data.result[i].groupName,
            value: res.data.result[i].totalCount,
          })
        }
        var option = chartsView1.getOption2(v)
        var div_ = document.getElementById('charts2')
        div_.removeAttribute('_echarts_instance_')
        var chart2 = this.$echarts.init(div_)
        chart2.setOption(option)
      })
    },
    // 维保年检统计（按月）
    drawView1Charts3: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/maintain/year/bymonth',
      }).then((res) => {
        var x = []
        var s1 = []
        if (res.data.result) {
          for (var i = 0; i < res.data.result.length; i++) {
            // x.push(res.data.result[i].perMonth + '月')
            // s1.push(res.data.result[i].totalCount)
            x[i] = res.data.result[i].groupName + '月'
            s1[i] = res.data.result[i].qty
          }
          this.perMonthList = x
          this.maintainBymonthList = s1
        }
        this.axios({
          headers: {
            orgId: sessionStorage.getItem('orgId'),
          },
          methods: 'get',
          url: process.env.API_ROOT + '/Visual/annual/year/bymonth',
        }).then((res) => {
          var s2 = []
          if (res.data.result) {
            for (var i = 0; i < res.data.result.length; i++) {
              s2.push(res.data.result[i].qty)
            }
            this.annualBymonthList = s2
          }
          var option = chartsView1.getOption3(
            this.perMonthList,
            this.maintainBymonthList,
            this.annualBymonthList
          )
          var div_ = document.getElementById('charts3')
          div_.removeAttribute('_echarts_instance_')
          var chart3 = this.$echarts.init(div_)
          chart3.setOption(option)
        })
      })
    },
    drawView1Charts4: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fault/year',
      }).then((res) => {
        var s = []
        s.push({
          name: '人工报警',
          value: res.data.result.totalAlarmCount,
        })
        s.push({
          name: '故障报警',
          value: res.data.result.totalFaultCount,
        })
        // for (var i = 0; i < res.data.result.length; i++) {
        //   s.push({
        //     name: res.data.result[i].faultName == '1' ? '人工报警' : '故障报警',
        //     value: res.data.result[i].happenCount
        //   })
        // }
        var option = chartsView1.getOption4(s, 8338)
        var div_ = document.getElementById('charts4')
        div_.removeAttribute('_echarts_instance_')
        var chart4 = this.$echarts.init(div_)
        chart4.setOption(option)
      })
    },
    drawView1Charts5: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fault/year/bymonth',
      }).then((res) => {
        var x = new Array(res.data.result.length)
        var s1 = new Array(res.data.result.length)
        var s2 = new Array(res.data.result.length)
        for (var i = 0; i < res.data.result.length; i++) {
          x[i] = res.data.result[i].groupName + '月'
          s1[i] = res.data.result[i].contrivedQty
          s2[i] = res.data.result[i].autoQty
        }
        var option = chartsView1.getOption5(x, s1, s2)
        var div_ = document.getElementById('charts5')
        div_.removeAttribute('_echarts_instance_')
        var chart5 = this.$echarts.init(div_)
        chart5.setOption(option)
      })
    },
    drawView1Charts6: function () {
      const cityId = sessionStorage.getItem('cityId')
      const regionType = sessionStorage.getItem('regionType')
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
          citytype: regionType,
          cityid: cityId,
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fault/year/byarea',
      }).then((res) => {
        var x = new Array(res.data.result.length)
        var s1 = new Array(res.data.result.length)
        var s2 = new Array(res.data.result.length)
        for (var i = 0; i < res.data.result.length; i++) {
          if (res.data.result[i].Name === '城步苗族自治县') {
            x[i] = '城步县'
          } else {
            x[i] = res.data.result[i].groupName
          }
          s1[i] = res.data.result[i].totalAlarmCount
          s2[i] = res.data.result[i].totalFaultCount
        }
        var option = chartsView1.getOption6(x, s1, s2)
        var div_ = document.getElementById('charts6')
        div_.removeAttribute('_echarts_instance_')
        var chart6 = this.$echarts.init(div_)
        chart6.setOption(option)
      })
    },
    drawView1Charts7: function () {
      const cityId = sessionStorage.getItem('cityId')
      const regionType = sessionStorage.getItem('regionType')
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
          citytype: regionType,
          cityid: cityId,
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fixing/byarea',
      }).then((res) => {
        // alert(res)
        var s1 = []
        if (res.data.result) {
          var x = new Array(res.data.result.length)
          for (var i = 0; i < res.data.result.length; i++) {
            // if (res.data.result[i].groupName == '安徽省') {
            //   res.data.result[i].totalCount = 2612
            // }
            x[i] = res.data.result[i].groupName
            s1.push(res.data.result[i].totalCount)
          }
          this.fixingByareaList = s1
        }
        this.axios({
          headers: {
            orgId: sessionStorage.getItem('orgId'),
            citytype: regionType,
            cityid: cityId,
          },
          methods: 'get',
          url: process.env.API_ROOT + '/Visual/gateway/byarea',
        }).then((res) => {
          // var s2 = new Array(res.data.result.length)
          // for (var i = 0; i < res.data.result.length; i++) {
          //   // if (res.data.result[i].groupName == '临泉县') {
          //   //   res.data.result[i].totalCount = 1214
          //   // }
          //   s2[i] = res.data.result[i].totalCount
          // }
          var s2 = new Array(x.length)
          for (var i = 0; i < x.length; i++) {
            var count = 0;
            for (var j = 0; j < res.data.result.length; j++) {
              if(x[i] == res.data.result[j].groupName){
                count = res.data.result[j].totalCount;
              }
            }
            s2[i] = count;
          }
          var option = chartsView1.getOption7(x, this.fixingByareaList, s2)
          var div_ = document.getElementById('charts7')
          div_.removeAttribute('_echarts_instance_')
          var chart7 = this.$echarts.init(div_)
          chart7.setOption(option)
        })
      })
    },
    drawView1Charts8: function (data) {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fault/year',
      }).then((res) => {
        var v1 = [
          res.data.result.totalAlarmCount,
          res.data.result.totalAlarmHandleCount,
        ]
        var v2 = [
          res.data.result.totalFaultCount,
          res.data.result.totalFaultHandleCount,
        ]
        this.faultTotalAlarmCount = v1
        this.faultTotalFaultCount = v2

        this.axios({
          headers: {
            orgId: sessionStorage.getItem('orgId'),
          },
          methods: 'get',
          url: process.env.API_ROOT + '/Visual/complaint/year',
        }).then((res) => {
          var v3 = [res.data.result.totalCount, res.data.result.handleCount]
          this.complaintYearTotalCount = v3
          var option = chartsView1.getOption8(
            this.faultTotalAlarmCount,
            this.faultTotalFaultCount,
            this.complaintYearTotalCount
          )
          var div_ = document.getElementById('charts8')
          div_.removeAttribute('_echarts_instance_')
          var chart8 = this.$echarts.init(div_)
          chart8.setOption(option)
        })
      })
    },
    // 全年处理统计
    drawView1Charts9: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fault/year',
      }).then((res) => {
        this.totalAlarmCount = res.data.result.totalAlarmCount
        this.totalFaultCount = res.data.result.totalFaultCount
        this.axios({
          headers: {
            orgId: sessionStorage.getItem('orgId'),
          },
          methods: 'get',
          url: process.env.API_ROOT + '/Visual/complaint/year',
        }).then((res) => {
          this.complaintTotalCount = res.data.result.totalCount
        })
      })
    },
  },
}
</script>
<style lang="css" rel="stylesheet/scss"  scoped>
.container {
  width: 100%;
  height: calc(100% - 40px);
  background: #0b133f;
}
.color1 {
  color: #4dffdd;
}
.color2 {
  color: #fe5050;
}
.color3 {
  color: #ffca6c;
}
.color4 {
  color: #1db7e5;
}
.bottom {
  height: calc(100% - 110px);
  width: 98%;
  display: inline-flex;
  padding-top: 10px;
}
.bottom .left {
  width: 23%;
  height: 100%;
}
.bottom .center {
  width: 54%;
  height: 100%;
}
.bottom .right {
  width: 23%;
  height: 100%;
}
.bottom .content {
  background: #121d49 !important;
  border-radius: 6px;
  border-radius: 6px !important;
}
.bottom .content label {
  display: block;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  text-align: left;
  padding-left: 10px;
  letter-spacing: 2px;
  width: 100%;
}
.bottom .left .row1 {
  height: calc(66% - 10px);
  width: 100%;
}
.bottom .left .row2 {
  margin-top: 10px;
  height: calc(34% - 10px);
  width: 100%;
}
.bottom .center .row1 {
  width: calc(100% - 20px);
  height: calc(20% - 10px);
  margin: 0px 10px 0px 10px;
}
.bottom .center .row1 .num {
  width: 100%;
  height: calc(100% - 30px);
  display: inline-flex;
}
.bottom .center .row1 .num div {
  width: 25%;
  height: 100%;
}
.bottom .center .row1 .num div span:nth-child(1) {
  display: flex;
  width: 100%;
  height: 35%;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
  justify-content: center;
  align-items: flex-end;
  font-size: 18px;
}
.bottom .center .row1 .num div span:nth-child(2) {
  display: block;
  width: 100%;
  height: 65%;
  letter-spacing: 2px;
  font-size: 32px;
}
.bottom .center .row2 {
  width: calc(100% - 20px);
  height: calc(47% - 18px);
  margin: 10px 10px 10px 10px;
  display: inline-flex;
}
.bottom .center .row2 .row2l1 {
  height: 100%;
  width: 50%;
  width: calc(38% - 5px);
  margin-right: 5px;
}
.bottom .center .row2 .row2l2 {
  height: 100%;
  width: calc(62% - 5px);
  margin-left: 5px;
}
.bottom .center .row3 {
  width: calc(100% - 20px);
  height: calc(33% - 2px);
  margin: 0px 10px 0px 10px;
}
.bottom .right .row1 {
  height: calc(66% - 10px);
  width: 100%;
}
.bottom .right .row2 {
  margin-top: 10px;
  height: calc(34% - 10px);
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/EchartsView1.vue